import React, { useState} from "react";
import { Box, Button, Grid, TextField, Snackbar, Alert} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CentreData } from "types/models/support/SupportApp";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

interface CentreProps {
  Centre?: CentreData;
}

const CentreCreate: React.FC<CentreProps> = ({ Centre }) => {
  const navigate = useNavigate();
  const [fileError, setFileError] = useState(false);

  const validationSchema = Yup.object({
    categoryName: Yup.string().required('categoryName is required'),
    parentCategory: Yup.string().required(' parentCategory is required'),
    type: Yup.string().required('type is required'),
     status: Yup.string().required('Status is required'),
  });



  const handleSubmit = (values: any) => {
    if (Centre) {
      console.log('Updating Centre:', values);
    } else {
      console.log('Creating Centre:', values);
    }
  };

  return (
    <Box sx={{ height: "100%", width: "100%", m:8   }}>
        
        <Grid sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", margin: 2 }}>
          <Formik
            initialValues={{
              categoryName: Centre ? Centre.categoryName : "",
              parentCategory: Centre ? Centre.parentCategory : "",
              type: Centre ? Centre.type : "",
              status: Centre ? Centre.status : "active",
              
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched }) => (
              <Form>
 


                <Grid container spacing={3} mb={3}>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="categoryName"
                      name="categoryName"
                      variant="outlined"
                      error={touched.categoryName && !!errors.categoryName}
                      helperText={<ErrorMessage name="categoryName" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="parentCategory"
                      name="parentCategory"
                      variant="outlined"
                      error={touched.parentCategory && !!errors.parentCategory}
                      helperText={<ErrorMessage name="parentCategory" />}
                    >
                    </Field>
                  </Grid>
                </Grid>

                <Grid container spacing={3} mb={3}>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="type"
                      name="type"
                      variant="outlined"
                      error={touched.type && !!errors.type}
                      helperText={<ErrorMessage name="type" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Select Status"
                      name="status"
                      select
                      variant="outlined"
                      SelectProps={{ native: true }}
                      error={touched.status && !!errors.status}
                      helperText={<ErrorMessage name="status" />}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Field>
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                    gap: 2,
                    paddingBottom: 2,
                    paddingTop: 2,
                    zIndex: 1000,
                    backgroundColor: "white",
                    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => navigate("/support/Centre/centre")}
                    sx={{ textTransform: "none", cursor: "pointer" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: "none", cursor: "pointer", right: 4 }}
                  >
                    {Centre ? "Add Centre" : "Update Centre"}
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
       
      </Grid>

      <Snackbar
        open={fileError}
        autoHideDuration={6000}
        onClose={() => setFileError(false)}
      >
        <Alert onClose={() => setFileError(false)} severity="error" sx={{ width: "100%" }}>
          {fileError ? "You can only upload one image." : "Centre added successfully!"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CentreCreate;
